import { render, staticRenderFns } from "./UiNumberInput.vue?vue&type=template&id=158a374b&"
import script from "./UiNumberInput.vue?vue&type=script&lang=js&"
export * from "./UiNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./UiNumberInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports